import { domain } from 'modules/data';
import { useSelector } from 'modules/react-redux';
import moment from 'moment';
import { FC, memo } from 'react';
import { getExchangeRateSourceName } from 'shared/helpers/exchangeRate';

import { getRequest } from '../../../selectors/pageSelectors';
import { messages } from './CurrencyDisclaimerLegacy.messages';
import { Container } from './CurrencyDisclaimerLegacy.styles';
import { CurrencyDisclaimerProps } from './CurrencyDisclaimerLegacy.types';

/**
 * @deprecated Use redesigned component {@link CurrencyDisclaimer}
 */
export const CurrencyDisclaimerLegacy: FC<CurrencyDisclaimerProps> = memo((props) => {
    const { className } = props;

    const request = useSelector(getRequest);

    let showDisclaimer = false;

    switch (request.integrationCode) {
        case domain.IntegrationCode.XeroBill:
        case domain.IntegrationCode.XeroPo:
        case domain.IntegrationCode.XeroQuote:
        case domain.IntegrationCode.XeroInvoice:
        case domain.IntegrationCode.QBooksBill:
        case domain.IntegrationCode.QBooksExpense:
        case domain.IntegrationCode.QBooksPo:
        case domain.IntegrationCode.QBooksInvoice:
            showDisclaimer = request.currency !== request.companyCurrency;
            break;

        default: {
            showDisclaimer = false;
        }
    }

    if (!showDisclaimer) return null;

    const sourceName = getExchangeRateSourceName(request.exchangeRateSource);

    const showXeroSyncDisclaimer =
        request.integrationType === domain.IntegrationType.Xero &&
        request.exchangeRateSource &&
        ![domain.ExchangeRateSource.Xero, domain.ExchangeRateSource.Manual, domain.ExchangeRateSource.None].includes(
            request.exchangeRateSource
        );

    const isManual = request.exchangeRateSource === domain.ExchangeRateSource.Manual;

    const sourceInfo =
        sourceName && request.exchangeRateDate
            ? `${moment.utc(request.exchangeRateDate).format('ll')}, ${sourceName}`
            : sourceName;

    return (
        <Container className={className}>
            {isManual && messages.manual}

            {messages.exchangeRateText({
                currency: request.currency,
                baseCurrency: request.companyCurrency,
                rate: request.exchangeRate,
            })}

            {sourceInfo && !isManual && ` (${sourceInfo})`}

            {showXeroSyncDisclaimer && '. ' + messages.xeroSyncDisclaimer}
        </Container>
    );
});

CurrencyDisclaimerLegacy.displayName = 'CurrencyDisclaimerLegacy';
